module.exports = __webpack_public_path__ + "static/devsecops-e974ebd13114671f75d08141d88331bc.png";